/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for processing actions on all DatasetPipeline.
 * @export
 * @interface DatasetPipelineProcess
 */
export interface DatasetPipelineProcess {
  /**
   *
   * @type {boolean}
   * @memberof DatasetPipelineProcess
   */
  generate: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPipelineProcess
   */
  perturb: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPipelineProcess
   */
  inference: boolean;
}

/**
 * Check if a given object implements the DatasetPipelineProcess interface.
 */
export function instanceOfDatasetPipelineProcess(value: object): value is DatasetPipelineProcess {
  if (!('generate' in value) || value['generate'] === undefined) return false;
  if (!('perturb' in value) || value['perturb'] === undefined) return false;
  if (!('inference' in value) || value['inference'] === undefined) return false;
  return true;
}

export function DatasetPipelineProcessFromJSON(json: any): DatasetPipelineProcess {
  return DatasetPipelineProcessFromJSONTyped(json, false);
}

export function DatasetPipelineProcessFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetPipelineProcess {
  if (json == null) {
    return json;
  }
  return {
    generate: json['generate'],
    perturb: json['perturb'],
    inference: json['inference'],
  };
}

export function DatasetPipelineProcessToJSON(value?: DatasetPipelineProcess | null): any {
  if (value == null) {
    return value;
  }
  return {
    generate: value['generate'],
    perturb: value['perturb'],
    inference: value['inference'],
  };
}
